/** Production snapshots run on localhost, with an explicit deployment origin.
 * Browser sessions never inherit the build-time origin: staging stays noindex.
 */
export function seoRobots(
  hostname: string,
  requested = 'index, follow',
  prerenderOrigin?: string,
): string {
  let targetHost = hostname;
  if (prerenderOrigin) {
    try { targetHost = new URL(prerenderOrigin).hostname; }
    catch { return 'noindex, nofollow'; }
  }
  return targetHost === 'bukietowa.pl' ? requested : 'noindex, nofollow';
}
